import React, { FC, CSSProperties, ReactNode } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import cx from 'classnames';

interface PillTitleProps {
	className?: string;
	style?: CSSProperties;
    children: ReactNode;
}

const useStyles = makeStyles((theme) => ({
	root: {
        borderRadius: 16,
        padding: '8px 18px',
        backgroundColor: 'var(--color-tertiary)',
        color: 'var(--color-white)',
        [theme.breakpoints.down('xs')]: {
        	padding: '13px 22px',
		}
	},
}));

const PillTitle: FC<PillTitleProps> = ({
    className, style, children
}) => {
	const classes = useStyles();

	return (<div className={cx(classes.root, className)} style={style}>
		<Typography variant='body1'>
			{ children }
		</Typography>
	</div>);
};

export default PillTitle;
